module.exports = {"540224100":"萨迦镇","540224101":"吉定镇","540224200":"雄麦乡","540224201":"麻布加乡","540224202":"雄玛乡","540224203":"扎西岗乡","540224204":"扯休乡","540224205":"赛乡","540224206":"拉洛乡","540224207":"查荣乡","540224208":"木拉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540224.json
// module id = 2691
// module chunks = 0